import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const STEPS = ['initializing...', 'loading modules...', 'compiling routes...', 'ready.'];

export default function Loader({ onDone }) {
  const [progress, setProgress] = useState(0);
  const [stepIdx, setStepIdx] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const targets = [40, 72, 90, 100];
    let i = 0;

    const tick = setInterval(() => {
      setProgress(targets[i]);
      setStepIdx(i);
      i++;
      if (i >= targets.length) {
        clearInterval(tick);
        setTimeout(() => {
          setVisible(false);
          setTimeout(onDone, 500);
        }, 400);
      }
    }, 380);

    return () => clearInterval(tick);
  }, [onDone]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="fixed inset-0 z-[999] bg-navy-900 flex flex-col items-center justify-center"
        >
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.4 }}
            className="text-center"
          >
            {/* Logo */}
            <div className="font-sans font-black text-5xl text-gold mb-2 tracking-tight">
              NS<span className="text-white/30">.</span>
            </div>
            <div className="font-mono text-xs text-gray-500 tracking-widest mb-8">
              NITESH SHAW · PORTFOLIO
            </div>

            {/* Progress bar */}
            <div className="w-48 h-0.5 bg-navy-400/50 rounded-full overflow-hidden mb-3">
              <motion.div
                animate={{ width: `${progress}%` }}
                transition={{ duration: 0.35, ease: 'easeOut' }}
                className="h-full bg-gold rounded-full"
              />
            </div>

            {/* Step text */}
            <AnimatePresence mode="wait">
              <motion.p
                key={stepIdx}
                initial={{ opacity: 0, y: 6 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -6 }}
                transition={{ duration: 0.2 }}
                className="font-mono text-xs text-gray-500 tracking-widest"
              >
                {STEPS[stepIdx]}
              </motion.p>
            </AnimatePresence>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
